import React, { useState } from 'react'
import { useExercise } from './../ExerciseProvider'
import { useTranslation } from '../../../hooks/useTranslation'
import { Input } from '~/lib/ui/input'
import { useIsDesktop } from '~/hooks/useMediaQuery'
import { TrashIcon } from '~/components/job_search/AlertsPage/icons'

const AddFriend = ({ slug, className }) => {
  const {
    trackContent,
    exerciseIndex,
    setTrackContent,
    formattedExerciseName,
  } = useExercise()
  const isDesktop = useIsDesktop()
  const { t } = useTranslation(formattedExerciseName)
  const pageOneTranslations = t('pages.0')
  const savedFriends = trackContent[exerciseIndex]?.[slug] || []
  const [friends, setFriends] = useState(
    savedFriends.length > 0 ? savedFriends : [{ friend: '', scale: 5 }],
  )

  const updateNestedResponse = (section, slug, response) => {
    setTrackContent((prevContent) => {
      const updatedSection = { ...prevContent[section] }
      updatedSection[slug] = response

      return {
        ...prevContent,
        [section]: updatedSection,
      }
    })
  }

  const handleChange = (index, event) => {
    const newFriends = [...friends]
    newFriends[index].friend = event.target.value
    setFriends(newFriends)
    updateNestedResponse(0, slug, newFriends)
  }

  const handleRelationChange = (index, value) => {
    const newFriends = [...friends]
    newFriends[index].scale = value
    setFriends(newFriends)
    updateNestedResponse(0, slug, newFriends)
  }

  const addAnotherFriend = () => {
    const newFriends = [...friends, { friend: '', scale: 5 }]
    setFriends(newFriends)
    updateNestedResponse(0, slug, newFriends)
  }

  const removeFriend = (index) => {
    const newFriends = friends.filter((_, i) => i !== index)
    setFriends(newFriends)
    updateNestedResponse(0, slug, newFriends)
  }

  return (
    <>
      {isDesktop && (
        <div className={`items ${className} space-y-4`}>
          {friends.map((item, index) => (
            <div key={index} className="flex items-center gap-x-12">
              <Input
                onChange={(e) => handleChange(index, e)}
                value={item.friend}
                type="text"
                className="max-w-80"
              />
              <div className="flex space-x-4">
                {[1, 2, 3, 4, 5].map((value) => (
                  <button
                    key={value}
                    onClick={() => handleRelationChange(index, value)}
                    className={`flex h-8 w-8 items-center justify-center rounded-full border ${
                      item.scale === value
                        ? 'bg-primary-button-cd text-white'
                        : 'bg-white text-gray-700'
                    }`}
                  >
                    {value}
                  </button>
                ))}
                <button
                  onClick={() => removeFriend(index)}
                  className="font-roboto-light ml-auto text-sm font-medium text-red-600 hover:text-red-800 focus:underline focus:outline-none"
                >
                  {pageOneTranslations.delete}
                </button>
              </div>
            </div>
          ))}
          <button
            onClick={addAnotherFriend}
            className="font-roboto-light mt-4 text-sm font-medium text-primary hover:text-primary-darker-75 focus:underline focus:outline-none"
          >
            + {pageOneTranslations.add_friend}
          </button>
        </div>
      )}
      {!isDesktop && (
        <div className={`items ${className} space-y-4`}>
          {friends.map((item, index) => (
            <div key={index} className="items-center gap-x-12">
              <div className="flex items-center">
                <Input
                  onChange={(e) => handleChange(index, e)}
                  value={item.friend}
                  type="text"
                  className="mb-4"
                />
                <button
                  onClick={() => removeFriend(index)}
                  className="mb-3 ml-2 flex"
                >
                  <TrashIcon
                    className={
                      'h-5 w-5 bg-transparent text-red-500 hover:bg-transparent hover:text-red-400'
                    }
                  />
                </button>
              </div>
              <div className="flex justify-center space-x-4">
                {[1, 2, 3, 4, 5].map((value) => (
                  <button
                    key={value}
                    onClick={() => handleRelationChange(index, value)}
                    className={`flex h-8 w-8 items-center justify-center rounded-full border ${
                      item.scale === value
                        ? 'bg-primary-button-cd text-white'
                        : 'bg-white text-gray-700'
                    }`}
                  >
                    {value}
                  </button>
                ))}
              </div>
            </div>
          ))}
          <button
            onClick={addAnotherFriend}
            className="font-roboto-light mt-4 text-sm font-medium text-primary hover:text-primary-darker-75 focus:underline focus:outline-none"
          >
            + {pageOneTranslations.add_friend}
          </button>
        </div>
      )}
    </>
  )
}

export default AddFriend
